import pixelService from "./pixelService";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const VID_KEY = "ms_vid";
let extra = {}; // stage overrides set by checkout pages (pix_generated / paid)
let timer = null;

const visitorId = () => {
  try {
    let v = localStorage.getItem(VID_KEY);
    if (!v) { v = `v_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`; localStorage.setItem(VID_KEY, v); }
    return v;
  } catch (e) { return "anon"; }
};

const firstTouchUtm = () => {
  try {
    const stored = sessionStorage.getItem("ms_utm");
    if (stored) return JSON.parse(stored);
    const p = new URLSearchParams(window.location.search);
    const utm = { utm_source: p.get("utm_source") || (p.get("fbclid") ? "facebook" : ""), utm_campaign: p.get("utm_campaign") || "" };
    if (utm.utm_source || utm.utm_campaign) sessionStorage.setItem("ms_utm", JSON.stringify(utm));
    return utm;
  } catch (e) { return {}; }
};

const cartInfo = () => {
  try {
    const cart = JSON.parse(localStorage.getItem("hestia_cart") || "[]");
    return { cart_count: cart.reduce((s, i) => s + (Number(i.quantity) || 1), 0), cart_total: cart.reduce((s, i) => s + (Number(i.price) || 0) * (Number(i.quantity) || 1), 0) };
  } catch (e) { return { cart_count: 0, cart_total: 0 }; }
};

const stageFor = (path) => {
  if (extra.stage) return extra.stage;
  if (path === "/") return "home";
  if (path.startsWith("/produto/")) return "product";
  if (path === "/carrinho") return "cart";
  if (path.startsWith("/checkout")) {
    const u = pixelService.userData || {};
    return u.email || u.phone || u.name ? "checkout_filling" : "checkout";
  }
  if (path.startsWith("/payment/success")) return "paid";
  return "other";
};

export const sendPresence = (useBeacon = false) => {
  try {
    const path = window.location.pathname;
    if (path.startsWith("/painel")) return;
    const u = pixelService.userData || {};
    const attr = pixelService.getAttribution ? pixelService.getAttribution() : {};
    const payload = {
      visitor_id: visitorId(), path, stage: stageFor(path),
      product_id: path.startsWith("/produto/") ? decodeURIComponent(path.split("/")[2] || "") : (extra.product_id || null),
      order_id: extra.order_id || null,
      ...cartInfo(), ...firstTouchUtm(),
      name: u.name || null, email: u.email || null, phone: u.phone || null,
      referrer: attr.referrer_url || null, fbc: !!attr.fbc, client_ip: attr.client_ip || null,
    };
    const body = JSON.stringify(payload);
    if (useBeacon && navigator.sendBeacon) { navigator.sendBeacon(`${API}/presence`, new Blob([body], { type: "application/json" })); return; }
    fetch(`${API}/presence`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
  } catch (e) {}
};

// Checkout pages call this when the PIX is generated / paid so the admin sees the exact step
export const setPresenceStage = (stage, data = {}) => {
  extra = { ...extra, stage, ...data };
  sendPresence();
};

export const clearPresenceStage = () => { extra = {}; };

export const startPresence = () => {
  if (timer) return;
  sendPresence();
  timer = setInterval(sendPresence, 15000);
  document.addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") sendPresence(true); else sendPresence(); });
  window.addEventListener("pagehide", () => sendPresence(true));
  window.addEventListener("ms:userdata", () => sendPresence()); // customer typed name/email/phone -> "preenchendo dados"
};
